import React, { useState } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import Modal from "@alboompro/boom-components/data-display/modal";
import HistoryModalContent from "../HistoryModalContent";
import { StatusContainer } from "./styles";

const LastSaved = ({ savingPage, pageContent, locale }) => {
  const [visible, setVisible] = useState(false);

  if (!pageContent) {
    return null;
  }
  const lang = locale;
  const lastUpdate = new Date(pageContent.updated_at);

  const today = new Date();
  const diffTime = Math.abs(today.getTime() - lastUpdate.getTime());
  let textAutosave = "header.autosave.success";

  if (diffTime / (1000 * 3600) >= 1) {
    const formattedDate = new Intl.DateTimeFormat(lang).format(lastUpdate);
    textAutosave = `${I18n.t("header.autosave.lastSaved")} ${formattedDate}`;
  }

  const textKey = savingPage ? "header.autosave.saving" : textAutosave;

  const handleModal = () => {
    setVisible(!visible);
  };

  return (
    <div>
      <StatusContainer onClick={handleModal}>{I18n.t(textKey)}</StatusContainer>
      <Modal 
        bodyStyle={{ height: "650px" }}
        title={I18n.t("historyModal.title")}
        visible={visible}
        width={1050}
        onClose={handleModal}
      >
        <HistoryModalContent />
      </Modal>
    </div>
  );
};

const mapDispatchToProps = {};

const mapStateToProps = state => ({
  savingPage: state.editor.savingPage,
  pageContent: state.page.page_content,
  locale: state.i18n.locale
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LastSaved);
